const actionTypes = {
    GIFT_CARD_APPLIED: 'GIFT_CARD_APPLIED',
    ORDER_ERRORS: 'ORDER_ERRORS',
    ORDER_REVIEW_TOGGLE: 'ORDER_REVIEW_TOGGLE',
    PAYMENT_CARD_NUMBER_CHANGED: 'PAYMENT_CARD_NUMBER_CHANGED',
    PAYMENT_CARDS_DETECTED: 'PAYMENT_CARDS_DETECTED',
    SECTION_SAVED: 'SECTION_SAVED',
    SET_PLACE_ORDER_PRE_HOOK: 'SET_PLACE_ORDER_PRE_HOOK',
    SUBMITTED_ORDER: 'SUBMITTED_ORDER',
    TOGGLE_CVC_INFO_MODAL: 'TOGGLE_CVC_INFO_MODAL',
    TOGGLE_PLACE_ORDER: 'TOGGLE_PLACE_ORDER',
    UPDATE_DELIVERY_INSTRUCTIONS: 'UPDATE_DELIVERY_INSTRUCTIONS',
    UPDATE_ORDER_GIFT_WRAP_OPTIONS: 'UPDATE_ORDER_GIFT_WRAP_OPTIONS',
    UPDATE_ORDER: 'UPDATE_ORDER',
    UPDATE_SHIPPING_METHODS: 'UPDATE_SHIPPING_METHODS',
    VALIDATE_ADDRESS: 'VALIDATE_ADDRESS'
};

module.exports = actionTypes;
